import styles from './index.module.scss';

const Primary = ({ children, style = {} }) => {
  return (
    <div className={styles.primary} style={style}>
      {children}
    </div>
  );
};

export default Primary;
